import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostBinding,
  input,
  InputSignal,
  Signal,
} from '@angular/core';
import { EnViewportSize } from '@core/api/enums/viewport-sizes.enums';
import {
  preFooterImages1,
  preFooterImages2,
  preFooterImages3,
  preFooterImages4,
  preFooterImagesDark1,
  preFooterImagesDark2,
  preFooterImagesDark3,
  preFooterImagesDark4,
} from '@layout/footer/footer.db';
import { PreFooterImports } from '@layout/pre-footer/pre-footer.imports';
import { NODA_FORM_ROUTER_LINK } from '@shared/constants/links';
import { ICardImages } from '@shared/interfaces/card.interface';

@Component({
  standalone: true,
  selector: 'noda-pre-footer',
  templateUrl: './pre-footer.component.html',
  styleUrls: ['./pre-footer.component.scss'],
  imports: PreFooterImports,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreFooterComponent {
  public readonly buttonLink: string = NODA_FORM_ROUTER_LINK;
  public enViewportSize: typeof EnViewportSize = EnViewportSize;
  private images: Signal<ICardImages[]> = computed((): ICardImages[] =>
    this.darkModeEnable()
      ? [
          preFooterImagesDark1,
          preFooterImagesDark2,
          preFooterImagesDark3,
          preFooterImagesDark4,
        ]
      : [
          preFooterImages1,
          preFooterImages2,
          preFooterImages3,
          preFooterImages4,
        ],
  );

  public title: InputSignal<string> = input<string>('common.footer.ultimate-provider');
  public subtitle: InputSignal<string> = input<string>('common.footer.lets-get-in-touch');
  public text: InputSignal<string | null> = input<string | null>('common.footer.features-release');
  public buttonText: InputSignal<string> = input<string>('common.call-to-action.get-started');
  public darkModeEnable: InputSignal<boolean> = input(false);

  public currentImage: Signal<ICardImages> = computed(() => {
    const randomIndex: number = Math.floor(Math.random() * 4);
    const currentCollection: ICardImages[] = this.images();

    return currentCollection[randomIndex];
  });

  @HostBinding('class.dark-mode') private get darkMode(): boolean {
    return this.darkModeEnable();
  }
  @HostBinding('class.white-mode') private get whiteMode(): boolean {
    return !this.darkModeEnable();
  }
}
